<template>
  <el-dialog
    title="价格方案详情"
    :visible.sync="dialogVisible"
    width="700px"
    :before-close="handleClose"
    @close="handleClose"
    class="price-detail-dialog"
  >
    
    <div v-if="priceInfo" class="price-info">
      <el-card class="info-card" shadow="never">
        <div slot="header" class="card-header">
          <span>基础信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">价格方案名称：</span>
              <span class="info-value">{{ priceInfo.price_name }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">公司名称：</span>
              <span class="info-value">{{ priceInfo.company_name }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">签署协议的公司名称：</span>
              <span class="info-value">{{ priceInfo.price_company_name }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">保险公司类型：</span>
              <span class="info-value">{{ formatInsuranceType(priceInfo.insurance_type) }}</span>
            </div>
          </el-col>
        </el-row>
      </el-card>
      
      <el-card class="info-card" shadow="never" style="margin-top: 20px;">
        <div slot="header" class="card-header">
          <span>费用信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">费率：</span>
              <span class="info-value rate-value">{{ formatPremiumRate(priceInfo.premium_rate) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">最低保费：</span>
              <span class="info-value money-value">{{ formatMoney(priceInfo.min_premium) }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">最高保险限额：</span>
              <span class="info-value money-value">{{ formatYuanAmount(priceInfo.max_coverage) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">协议扫描件：</span>
              <span class="info-value">
                <el-link 
                  v-if="priceInfo.protocol_url" 
                  :href="priceInfo.protocol_url" 
                  target="_blank" 
                  type="primary"
                >
                  查看协议
                </el-link>
                <span v-else class="no-data">无</span>
              </span>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
    
    <div v-else class="no-data-tip">
      暂无价格方案信息
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="medium">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { formatMoney } from '@/utils/formatter'

export default {
  name: 'PriceDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      priceData: [
        {
          name: '基础方案',
          coverage: '100',
          price: '200',
          description: '适用于小型货物运输'
        },
        {
          name: '标准方案',
          coverage: '500',
          price: '500',
          description: '适用于中型货物运输'
        },
        {
          name: '高级方案',
          coverage: '1000',
          price: '1000',
          description: '适用于大型货物运输'
        }
      ],
      priceInfo: null
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        // 获取价格方案详情
        if (this.$parent.currentUser && this.$parent.currentUser.priceInfo) {
          this.priceInfo = this.$parent.currentUser.priceInfo
        }
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    formatMoney,
    formatYuanAmount(value) {
      if (value === null || value === undefined || value === '') return ''
      return Number(value).toLocaleString('zh-CN', { minimumFractionDigits: 2 }) + '元'
    },
    formatInsuranceType(value) {
      // 这里应该从父组件获取保险公司类型映射
      const insuranceTypeMap = this.$parent.insuranceTypeMap || {}
      return insuranceTypeMap[value] || '未知'
    },
    formatPremiumRate(value) {
      if (!value) return ''
      return (value / 10000) + '%'
    }
  }
}
</script>

<style lang="less" scoped>
.price-detail-dialog {
  /deep/ .el-dialog__body {
    padding: 20px 30px;
  }
  
  .info-card {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    
    .card-header {
      padding: 10px 20px;
      background-color: #f5f7fa;
      border-bottom: 1px solid #ebeef5;
      
      span {
        font-weight: 600;
        color: #303133;
      }
    }
    
    .info-item {
      display: flex;
      padding: 12px 0;
      min-height: 40px;
      align-items: center;
      
      .info-label {
        width: 150px;
        text-align: right;
        color: #606266;
        font-size: 14px;
        flex-shrink: 0;
      }
      
      .info-value {
        flex: 1;
        color: #303133;
        font-size: 14px;
        word-break: break-all;
        padding-left: 10px;
        
        &.rate-value {
          color: #e6a23c;
          font-weight: 500;
        }
        
        &.money-value {
          color: #67c23a;
          font-weight: 500;
        }
        
        .no-data {
          color: #909399;
        }
      }
    }
  }
  
  .no-data-tip {
    text-align: center;
    padding: 40px 0;
    color: #909399;
    font-size: 14px;
  }
  
  .dialog-footer {
    text-align: center;
    padding: 20px 0 0;
  }
}
</style>
